"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";
import { shopifyDeveloperLevels, shopifyTechnicalSkills, shopifyNonTechnicalSkills } from "./shopify.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
interface ShopifyProjectRequirementsProps {
  heading?: string;
  subtitle?: string;
  className?: string;
}
export default function ShopifyProjectRequirements(t0) {
  const $ = _c(74);
  const {
    heading: t1,
    subtitle: t2,
    className: t3
  } = t0;
  const heading = t1 === undefined ? "Hire Best Shopify Developers As Per Project Requirements" : t1;
  const subtitle = t2 === undefined ? "Our Shopify experts cover every aspect of the skills required to develop and maintain a successful Shopify store. Look at their technical and interpersonal skills before hiring." : t2;
  const className = t3 === undefined ? "" : t3;
  const desktopAnimations = useDesktopAnimations();
  const t4 = `relative overflow-hidden bg-white py-16 font-sans transition-colors duration-300 sm:py-20 lg:py-24 dark:bg-[#070b14] ${className}`;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="pointer-events-none absolute inset-0 opacity-40 bg-[radial-gradient(circle,rgba(75,88,125,.18)_0.8px,transparent_0.9px)] bg-[length:12px_12px]" aria-hidden="true" />;
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  let t6;
  if ($[1] !== desktopAnimations) {
    t6 = desktopAnimations ? {
      opacity: 0,
      y: 30
    } : false;
    $[1] = desktopAnimations;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== desktopAnimations) {
    t7 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[3] = desktopAnimations;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== desktopAnimations) {
    t8 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[5] = desktopAnimations;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t10;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      once: true
    };
    t10 = {
      duration: 0.7,
      ease
    };
    $[7] = t10;
    $[8] = t9;
  } else {
    t10 = $[7];
    t9 = $[8];
  }
  let t11;
  if ($[9] !== heading) {
    t11 = <h2 className="font-poppins text-[30px] font-bold leading-tight text-[#0b1354] sm:text-[38px] lg:text-[44px] dark:text-white">{heading}</h2>;
    $[9] = heading;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== subtitle) {
    t12 = subtitle && <p className="font-sans mt-3 text-[14.5px] font-normal leading-[26px] text-[#66698a] sm:text-[16px] dark:text-gray-400">{subtitle}</p>;
    $[11] = subtitle;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t11 || $[14] !== t12 || $[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t13 = <motion.div initial={t6} whileInView={t7} animate={t8} viewport={t9} transition={t10} className="mx-auto mb-12 max-w-3xl text-center md:mb-14">{t11}{t12}</motion.div>;
    $[13] = t11;
    $[14] = t12;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== desktopAnimations) {
    t14 = desktopAnimations ? {
      opacity: 0,
      y: 35
    } : false;
    $[19] = desktopAnimations;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== desktopAnimations) {
    t15 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[21] = desktopAnimations;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== desktopAnimations) {
    t16 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[23] = desktopAnimations;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  let t18;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      once: true
    };
    t18 = {
      duration: 0.7,
      delay: 0.1,
      ease
    };
    $[25] = t17;
    $[26] = t18;
  } else {
    t17 = $[25];
    t18 = $[26];
  }
  let t19;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div aria-hidden={true} className="pointer-events-none absolute inset-y-0 right-0 z-10 w-10 rounded-r-[16px] bg-gradient-to-l from-white to-transparent md:hidden dark:from-gray-900" />;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <thead><tr className="bg-[#faeedd] dark:bg-[#2a241b]"><th className="w-1/4 px-6 py-4.5 font-poppins text-[15px] font-bold text-[#0b1354] sm:text-[16px] dark:text-white border-r border-[#f0e6d6] dark:border-gray-800" />{shopifyDeveloperLevels.map(_temp)}</tr></thead>;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <tr className="border-t border-[#f0e6d6] dark:border-gray-800 hover:bg-gray-50/50 dark:hover:bg-gray-800/40 transition-colors"><td className="px-6 py-4.5 font-poppins text-[14.5px] font-bold text-[#0b1354] sm:text-[15.5px] dark:text-white border-r border-[#f0e6d6] dark:border-gray-800">Years of Experience</td>{shopifyDeveloperLevels.map(_temp2)}</tr>;
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  let t22;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <tr className="border-t border-[#f0e6d6] dark:border-gray-800 hover:bg-gray-50/50 dark:hover:bg-gray-800/40 transition-colors"><td className="px-6 py-4.5 font-poppins text-[14.5px] font-bold text-[#0b1354] sm:text-[15.5px] dark:text-white border-r border-[#f0e6d6] dark:border-gray-800">Project Managed</td>{shopifyDeveloperLevels.map(_temp3)}</tr>;
    $[30] = t22;
  } else {
    t22 = $[30];
  }
  let t23;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="overflow-x-auto rounded-[16px]"><table className="w-full min-w-[620px] text-left border-collapse">{t20}<tbody>{t21}{t22}<tr className="border-t border-[#f0e6d6] dark:border-gray-800 hover:bg-gray-50/50 dark:hover:bg-gray-800/40 transition-colors"><td className="px-6 py-4.5 font-poppins text-[14.5px] font-bold text-[#0b1354] sm:text-[15.5px] dark:text-white border-r border-[#f0e6d6] dark:border-gray-800">Hours Completed</td>{shopifyDeveloperLevels.map(_temp4)}</tr></tbody></table></div>;
    $[31] = t23;
  } else {
    t23 = $[31];
  }
  let t24;
  if ($[32] !== t14 || $[33] !== t15 || $[34] !== t16) {
    t24 = <motion.div initial={t14} whileInView={t15} animate={t16} viewport={t17} transition={t18} className="relative rounded-[16px] border border-[#f0e6d6] bg-white shadow-sm dark:border-gray-800 dark:bg-gray-900">{t19}{t23}</motion.div>;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  let t25;
  if ($[36] !== desktopAnimations) {
    t25 = desktopAnimations ? {
      opacity: 0,
      y: 35
    } : false;
    $[36] = desktopAnimations;
    $[37] = t25;
  } else {
    t25 = $[37];
  }
  let t26;
  if ($[38] !== desktopAnimations) {
    t26 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[38] = desktopAnimations;
    $[39] = t26;
  } else {
    t26 = $[39];
  }
  let t27;
  if ($[40] !== desktopAnimations) {
    t27 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[40] = desktopAnimations;
    $[41] = t27;
  } else {
    t27 = $[41];
  }
  let t28;
  let t29;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = {
      once: true
    };
    t29 = {
      duration: 0.6,
      delay: 0.15,
      ease
    };
    $[42] = t28;
    $[43] = t29;
  } else {
    t28 = $[42];
    t29 = $[43];
  }
  let t30;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <h3 className="font-poppins mb-6 text-[20px] font-bold leading-tight text-[#0b1354] sm:text-[22px] dark:text-white">Technical Expert</h3>;
    $[44] = t30;
  } else {
    t30 = $[44];
  }
  let t31;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <article className="flex h-full flex-col justify-start rounded-[20px] border border-sky-100/70 bg-[#edf6fd] p-7 sm:p-8 md:p-9 shadow-sm dark:border-sky-950/60 dark:bg-[#13202e]">{t30}<ul className="flex flex-col gap-4">{shopifyTechnicalSkills.map(_temp5)}</ul></article>;
    $[45] = t31;
  } else {
    t31 = $[45];
  }
  let t32;
  if ($[46] !== t25 || $[47] !== t26 || $[48] !== t27) {
    t32 = <motion.div initial={t25} whileInView={t26} animate={t27} viewport={t28} transition={t29} className="h-full">{t31}</motion.div>;
    $[46] = t25;
    $[47] = t26;
    $[48] = t27;
    $[49] = t32;
  } else {
    t32 = $[49];
  }
  let t33;
  if ($[50] !== desktopAnimations) {
    t33 = desktopAnimations ? {
      opacity: 0,
      y: 35
    } : false;
    $[50] = desktopAnimations;
    $[51] = t33;
  } else {
    t33 = $[51];
  }
  let t34;
  if ($[52] !== desktopAnimations) {
    t34 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[52] = desktopAnimations;
    $[53] = t34;
  } else {
    t34 = $[53];
  }
  let t35;
  if ($[54] !== desktopAnimations) {
    t35 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[54] = desktopAnimations;
    $[55] = t35;
  } else {
    t35 = $[55];
  }
  let t36;
  let t37;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = {
      once: true
    };
    t37 = {
      duration: 0.6,
      delay: 0.25,
      ease
    };
    $[56] = t36;
    $[57] = t37;
  } else {
    t36 = $[56];
    t37 = $[57];
  }
  let t38;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <h3 className="font-poppins mb-6 text-[20px] font-bold leading-tight text-[#0b1354] sm:text-[22px] dark:text-white">Non-Technical Expertise</h3>;
    $[58] = t38;
  } else {
    t38 = $[58];
  }
  let t39;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <article className="flex h-full flex-col justify-start rounded-[20px] border border-rose-100/70 bg-[#fdf0f2] p-7 sm:p-8 md:p-9 shadow-sm dark:border-rose-950/60 dark:bg-[#25171b]">{t38}<ul className="flex flex-col gap-4">{shopifyNonTechnicalSkills.map(_temp6)}</ul></article>;
    $[59] = t39;
  } else {
    t39 = $[59];
  }
  let t40;
  if ($[60] !== t33 || $[61] !== t34 || $[62] !== t35) {
    t40 = <motion.div initial={t33} whileInView={t34} animate={t35} viewport={t36} transition={t37} className="h-full">{t39}</motion.div>;
    $[60] = t33;
    $[61] = t34;
    $[62] = t35;
    $[63] = t40;
  } else {
    t40 = $[63];
  }
  let t41;
  if ($[64] !== t32 || $[65] !== t40) {
    t41 = <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:gap-8 md:mt-12">{t32}{t40}</div>;
    $[64] = t32;
    $[65] = t40;
    $[66] = t41;
  } else {
    t41 = $[66];
  }
  let t42;
  if ($[67] !== t13 || $[68] !== t24 || $[69] !== t41) {
    t42 = <div className="relative z-10 mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">{t13}{t24}{t41}</div>;
    $[67] = t13;
    $[68] = t24;
    $[69] = t41;
    $[70] = t42;
  } else {
    t42 = $[70];
  }
  let t43;
  if ($[71] !== t4 || $[72] !== t42) {
    t43 = <section className={t4}>{t5}{t42}</section>;
    $[71] = t4;
    $[72] = t42;
    $[73] = t43;
  } else {
    t43 = $[73];
  }
  return t43;
}
function _temp6(skill_0, index_0) {
  return <li key={index_0} className="flex items-start gap-3"><FaCheckCircle className="mt-1 shrink-0 text-[16px] text-[#ef4444]" /><span className="font-sans text-[14px] leading-[23px] text-[#5e6282] sm:text-[15px] dark:text-gray-300">{skill_0}</span></li>;
}
function _temp5(skill, index) {
  return <li key={index} className="flex items-start gap-3"><FaCheckCircle className="mt-1 shrink-0 text-[16px] text-[#10b981]" /><span className="font-sans text-[14px] leading-[23px] text-[#5e6282] sm:text-[15px] dark:text-gray-300">{skill}</span></li>;
}
function _temp4(lvl_2) {
  return <td key={lvl_2.title} className="px-6 py-4.5 text-center font-sans text-[14.5px] font-normal text-[#5e6282] sm:text-[15px] dark:text-gray-300 border-r last:border-r-0 border-[#f0e6d6] dark:border-gray-800">{lvl_2.hoursCompleted}</td>;
}
function _temp3(lvl_1) {
  return <td key={lvl_1.title} className="px-6 py-4.5 text-center font-sans text-[14.5px] font-normal text-[#5e6282] sm:text-[15px] dark:text-gray-300 border-r last:border-r-0 border-[#f0e6d6] dark:border-gray-800">{lvl_1.projectsManaged}</td>;
}
function _temp2(lvl_0) {
  return <td key={lvl_0.title} className="px-6 py-4.5 text-center font-sans text-[14.5px] font-normal text-[#5e6282] sm:text-[15px] dark:text-gray-300 border-r last:border-r-0 border-[#f0e6d6] dark:border-gray-800">{lvl_0.experience}</td>;
}
function _temp(lvl) {
  return <th key={lvl.title} className="w-1/4 px-6 py-4.5 text-center font-poppins text-[14.5px] font-bold text-[#0b1354] sm:text-[15.5px] dark:text-white border-r last:border-r-0 border-[#f0e6d6] dark:border-gray-800">{lvl.title}</th>;
}